module.exports = __webpack_public_path__ + "img/28c-produtividade-falta.2f8b7548.png";